module.exports = __webpack_public_path__ + "media/images/iconLockOpen--dark-160954bc2fd29d0594da66130f6f393a.png";